/**
 * Ticket Notifications Composable
 *
 * Tracks new ticket count for the SideNav badge via Socket.IO events.
 * Count resets when the user navigates to the tickets page.
 */

import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useTicketStream } from './useTicketStream'

const newTicketCount = ref(0)

let initialized = false

export function useTicketNotifications() {
  const route = useRoute()

  if (!initialized) {
    initialized = true
    const { onTicketCreated } = useTicketStream()

    onTicketCreated(() => {
      // Only increment if not currently on the tickets page
      if (!route.path.startsWith('/tickets')) {
        newTicketCount.value++
      }
    })
  }

  // Reset count when navigating to tickets
  watch(() => route.path, (path) => {
    if (path.startsWith('/tickets')) {
      newTicketCount.value = 0
    }
  })

  return {
    newTicketCount,
  }
}
